import { FC, useState, useEffect } from 'react'
import style from './style.m.less'

interface ICountdownTimer {
    blockEndTime: Date
    onTimeout?: () => void
}

const CountdownTimer: FC<ICountdownTimer> = ({ blockEndTime, onTimeout }) => {
    const [finishTime] = useState(blockEndTime.getTime())
    const [[diffDays, diffH, diffM, diffS], setDiff] = useState([0, 0, 0, 0])
    const [tick, setTick] = useState(false)
    const [isTimeout, setIsTimeout] = useState(false)
    const [timerId, setTimerID] = useState<number | null>(null)

    useEffect(() => {
        const diff = (finishTime - new Date().getTime()) / 1000
        if (diff < 0) {
            setIsTimeout(true)
            onTimeout?.()
            return
        }
        setDiff([
            Math.floor(diff / 86400), // дни
            Math.floor((diff / 3600) % 24),
            Math.floor((diff / 60) % 60),
            Math.floor(diff % 60),
        ])
    }, [tick, finishTime])

    useEffect(() => {
        if (isTimeout && timerId !== null) {
            clearInterval(timerId)
        }
    }, [isTimeout, timerId])

    useEffect(() => {
        const timerID = window.setInterval(() => {
            setTick((prev) => !prev)
        }, 1000)
        setTimerID(timerID)
        return () => clearInterval(timerID)
    }, [])

    return (
        <div className={style.userBlockingTimerContainer}>
            <div className={style.userBlockingTimerText}>
                Аккаунт временно заблокирован. До конца блокировки осталось
            </div>
            <div className={style.userBlockingTimer}>
                {`${diffDays > 0 ? diffDays + ' дней ' : ''}`}
                {`
                    ${diffH.toString().padStart(2, '0')}:
                    ${diffM.toString().padStart(2, '0')}:
                    ${diffS.toString().padStart(2, '0')}
                `}
            </div>
        </div>
    )
}

export default CountdownTimer
